//@flow
import type {
  DeliveryMethod,
  ShippingRateDisplayItem,
} from '../../../entities/logistic/delivery-method';
import type {AdvancedMethod} from '../../../entities/logistic/delivery-method/advanced';
import type {FlatRateMethod} from '../../../entities/logistic/delivery-method/flat-rate';
import type {StandardMethod} from '../../../entities/logistic/delivery-method/standard';
import {commaFormat} from '../../../utils/number';

export function shippingRateItemAdapter(
  deliveryMethods: DeliveryMethod[],
  currencyCode: string
): ShippingRateDisplayItem[] {
  const shippingRateItems: any[] = deliveryMethods
    .map(method => {
      if (method.type === 'pickup-address') return undefined;
      if (method.type === 'store-shipping-method-flat-rate') {
        return shippingMethodFlatRateAdapter(method, currencyCode);
      }
      if (method.type === 'store-shipping-method-standard-setting') {
        return shippingMethodStandardAdapter(method, currencyCode);
      }

      if (method.type === 'store-shipping-method-advanced-admin-group') {
        return shippingMethodAdvancedAdapter(method, currencyCode);
      }
      return undefined;
    })
    .filter(Boolean)
    .flat();
  return shippingRateItems;
}

function shippingMethodFlatRateAdapter(
  flatRate: FlatRateMethod,
  currencyCode: string
): ShippingRateDisplayItem[] {
  return flatRate.shippingRates.map(rate => {
    const price = Number(rate.price);
    return {
      description: rate.description,
      enabled: rate.enabled,
      displayName: rate.name,
      id: rate.id,
      price: price === 0 ? 'Gratis' : commaFormat(price, currencyCode),
    };
  });
}

function shippingMethodStandardAdapter(
  flatRate: StandardMethod,
  currencyCode: string
): ShippingRateDisplayItem[] {
  return flatRate.shippingRates.map(rate => {
    const price = Number(rate.price);
    return {
      description: flatRate.description,
      enabled: rate.enabled,
      displayName: flatRate.displayName,
      id: rate.id,
      price: price === 0 ? 'Gratis' : commaFormat(price, currencyCode),
    };
  });
}

function shippingMethodAdvancedAdapter(
  advanced: AdvancedMethod,
  currencyCode: string
): ShippingRateDisplayItem[] {
  return advanced.shippingRates.map(rate => {
    const price = Number(rate.price);
    return {
      description: rate.description,
      enabled: rate.enabled,
      displayName: rate.name,
      id: rate.id,
      price: price === 0 ? 'Gratis' : commaFormat(price, currencyCode),
    };
  });
}
